module.exports = __webpack_public_path__ + "static/Artboard-11-b4321721a9b35b02814f7596d5fd8f30.png";